import * as types from './types'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    if (text !== undefined && text !== null) {
      state.searchTerm = text
    }
  },
  [types.SET_PAGE_SIZE](state, value) {
    if (value !== undefined && value !== null) {
      state.pageSize = parseInt(value)
    }
  },
  [types.SET_SORT_DIR](state, text) {
    if (text !== undefined && text !== null) {
      state.sortDir = text
    }
  },
  [types.SET_ORDER_BY](state, text) {
    if (text !== undefined && text !== null) {
      state.orderBy = text
    }
  },
  [types.SET_STATUS](state, value) {
    if (value !== undefined && value !== null) {
      state.status = value
    }
  },
  [types.SET_FILTER_BY](state, value) {
    if (value !== undefined && value !== null) {
      state.filterBy = parseInt(value)
    }
  },
  [types.SET_SERVICE_REQUEST](state, data) {
    state.serviceRequest = null
    if (data !== undefined && data !== null) {
      if (Array.isArray(data)) {
        state.serviceRequest = data[0]
      } else {
        state.serviceRequest = data
      }
    }
  },
  [types.SET_SERVICE_REQUESTS](state, data) {
    state.serviceRequests = { count: 0, items: [] }
    if (data !== undefined && data !== null) {
      if (data.count === null) {
        data.count = 0
      }
      if (data.items === null) {
        data.items = []
      }
      state.serviceRequests = data
    }
  },
  [types.SET_SERVICE_REQUEST_HISTORY](state, data) {
    state.requestHistory = data
  },
  [types.SET_SERVICE_REQUEST_ISSUES](state, data) {
    state.issues = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.issues = data
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/mutations.js